import { useParams, useNavigate } from "react-router-dom";
import SaleDetails, {
  fetchSale,
  fetchSaleItems,
  fetchPayments,
} from "./SaleDetails";
import Navbar from "../../../components/Navbar";
import Subnav from "../SubNav";
import Footer from "../../../components/Footer";

export default function SaleDetailsPage() {
  const { id } = useParams(); // get /sales/:id
  const navigate = useNavigate();

  return (
    <div>
      <Navbar />
      <Subnav />
      <div className="min-h-screen bg-gray-50">
        <SaleDetails
          saleId={id}
          fetchSale={fetchSale}
          fetchSaleItems={fetchSaleItems}
          fetchPayments={fetchPayments}
          onBack={() => navigate(-1)} // go back
        />
      </div>
      <Footer />
    </div>
  );
}
